import { writable, get } from 'svelte/store'

const _targetCard = writable(null)
const _sourceCard = writable(null)
const _zoomDiscard = writable(false)
const _zoomDeck = writable(false)
const _deckCardVisible = writable(false)
const _deckSelected = writable(false)
const _discardSelected = writable(false)
const _cardsInitialized = writable(0)
const _handOver = writable(false)
const _gameOver = writable(false)
const _endRound = writable(false)

function targetCard(newCard) {
  if (newCard) {
    _targetCard.set(newCard)
  }
  return get(_targetCard)
}

function sourceCard(newCard) {
  if (newCard) {
    _sourceCard.set(newCard)
  }
  return get(_sourceCard)
}

function cardsInitialized(val) {
  if (val) {
    _cardsInitialized.set(val)
  }
  return get(_cardsInitialized)
}

function zoomDiscard(val) {
  if (val) {
    _zoomDiscard.set(val)
  }
  return get(_zoomDiscard)
}

function zoomDeck(val) {
  if (val) {
    _zoomDeck.set(val)
  }
  return get(_zoomDeck)
}

function deckCardVisible(val) {
  if (val) {
    _deckCardVisible.set(val)
  }
  return get(_deckCardVisible)
}

function deckSelected(val) {
  if (val) {
    _deckSelected.set(val)
  }
  return get(_deckSelected)
}

function discardSelected(val) {
  if (val) {
    _discardSelected.set(val)
  }
  return get(_discardSelected)
}

function handOver(val) {
  if (val) {
    _handOver.set(val)
  }
  return get(_handOver)
}

function gameOver(val) {
  if (val) {
    _gameOver.set(val)
  }
  return get(_gameOver)
}

function endRound(val) {
  if (val) {
    _endRound.set(val)
  }
  return get(_endRound)
}

function clearStores() {
  _targetCard.set(null)
  _sourceCard.set(null)
  _discardSelected.set(false)
  _deckSelected.set(false)
  _deckCardVisible.set(false)
  _zoomDeck.set(false)
  _zoomDiscard.set(false)
}

export {
  targetCard,
  sourceCard,
  cardsInitialized,
  zoomDiscard,
  _zoomDiscard,
  zoomDeck,
  _zoomDeck,
  deckCardVisible,
  deckSelected,
  discardSelected,
  handOver,
  gameOver,
  endRound,
  clearStores
}
